import { useButton } from '@react-aria/button'
import { forwardRef } from 'react'
import { useObjectRef } from 'utils/useObjectRef'
import Styles from './TextEditingDrawer.module.scss'
import { Grid } from 'blaze-ui/icons'

interface Props {
  onPress: () => void
}

export const SeeAllButton = forwardRef<HTMLDivElement, Props>(({ onPress }: Props, fRef) => {
  const ref = useObjectRef(fRef)
  const { buttonProps } = useButton({ onPress, elementType: 'div' }, ref)

  return (
    <div {...buttonProps} className={Styles.seeAllButton}>
      <Grid />
      See All
    </div>
  )
})
